import { jsx, Fragment } from 'react/jsx-runtime';
import { useContext, useMemo, useCallback } from 'react';
import { permissionCheck } from '../core/check/check.js';
import '../core/types.js';
import { PermissionContext } from './context.js';

const usePermission = (permissions)=>{
    const { authenticated, plugins, loading, roles } = useContext(PermissionContext);
    /**
     * Check Permission.
     */ const permissionResult = useMemo(()=>permissionCheck(permissions).plugins(plugins).authenticated(authenticated).verify(roles), [
        authenticated,
        plugins,
        permissions,
        roles
    ]);
    const { isAuthorized } = permissionResult;
    // Authorized
    // Simple wrapper to authorize children render.
    const Authorized = useCallback(({ children })=>jsx(Fragment, {
            children: isAuthorized ? children : null
        }), [
        isAuthorized
    ]);
    // Unauthorized
    // Simple wrapper to render children when no permission authorized.
    const Unauthorized = useCallback(// Only render the children if a user does not have the roles and not in loading state.
    // There could be a case where a user can have the roles but gets a value of false
    // for isAuthorized in loading state.
    ({ children })=>jsx(Fragment, {
            children: !isAuthorized && !loading ? children : null
        }), [
        isAuthorized,
        loading
    ]);
    const checkPermission = useCallback((permissions)=>permissionCheck(permissions).plugins(plugins).authenticated(authenticated).verify(roles), [
        authenticated,
        plugins,
        roles
    ]);
    return [
        {
            Authorized,
            Unauthorized
        },
        {
            loading,
            checkPermission,
            ...permissionResult
        }
    ];
};

export { usePermission };
//# sourceMappingURL=index.js.map
